import { PropertyStatus, PROPERTY_STATUS_LABELS } from "../constants/property-status";

export function getStatusLabel(status: PropertyStatus): string {
  if (!(status in PROPERTY_STATUS_LABELS)) return "Unknown";
  return PROPERTY_STATUS_LABELS[status];
}
